import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/PdfRepToolPage.css';

const PdfRepToolPage: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>('');
  const navigate = useNavigate();

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedOption(value);
    
    switch(value) {
      case 'hillerbrand-fda':
        navigate('/outil-fda-pdf');
        break;
      case 'mon-devis':
        navigate('/admin/pdf-tool');
        break;
      case 'mon-devis-ttb':
        navigate('/admin/pdf-tool-devis');
        break;
      case 'devis-foodinnov':
        // TODO: Ajouter la redirection vers la page de devis Foodinnov quand elle sera créée
        console.log('Redirection vers devis Foodinnov à implémenter');
        break;
      case 'ma-facture':
        navigate('/outil-facture-pdf');
        break;
      case 'facture-zak':
        navigate('/outil-facture-zak-pdf');
        break;
      default:
        break;
    }
  };

  return (
    <div className="pdf-rep-tool-container">
      <Header
        isAuthenticated={true}
        onLoginClick={() => {}}
        onHomeClick={() => {}}
        onLogoutClick={() => {}}
      />
      <main className="pdf-rep-tool-content">
        <h1 style={{ marginBottom: '20px' }}>Outil de Repérage PDF</h1>
        <div className="selection-container">
          <select 
            value={selectedOption} 
            onChange={handleSelectChange}
            className="pdf-rep-select"
          >
            <option value="">Sélectionnez un type de document</option>
            <option value="mon-devis">Devis (FDA Registration)</option>
            <option value="mon-devis-ttb">Mon Devis (TTB Registration)</option>
            <option value="hillerbrand-fda">Hillerbrand FDA</option>
            <option value="ma-facture">Ma Facture</option>
            <option value="facture-zak">Facture Zak</option>
          </select>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PdfRepToolPage; 